import { en, type Strings } from "./strings/en";
import { uz } from "./strings/uz";
import { ru } from "./strings/ru";
import { isLocale, LOCALE_STORAGE_KEY, type Locale } from "./locale-context";

export type { Locale, Strings };
export { LOCALES, LOCALE_LABELS, LOCALE_TAG, isLocale, useLocale, useT } from "./locale-context";

export const STRINGS: Record<Locale, Strings> = { en, uz, ru };

/** Locale a static path pins: /uz → uz, /ru → ru, anything else → null. */
export function localeFromPath(pathname: string): Locale | null {
  const seg = pathname.replace(/^\/+/, "").split("/")[0];
  return seg === "uz" || seg === "ru" ? seg : null;
}

/**
 * Resolution order: URL-pinned static page → what the user last chose
 * (localStorage, also set by the static /uz and /ru pages so the sign-in and
 * app routes inherit it) → browser language → English.
 */
export function detectLocale(): Locale {
  try {
    const fromPath = localeFromPath(window.location.pathname);
    if (fromPath) return fromPath;
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isLocale(stored)) return stored;
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("uz")) return "uz";
    if (nav.startsWith("ru")) return "ru";
  } catch {
    /* SSR / storage blocked */
  }
  return "en";
}

export function persistLocale(l: Locale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, l);
  } catch {
    /* ignore */
  }
}
